import { useEffect, useState } from "react"
import { EntryMode, PutAccommodationSetEntry } from "../../../models/Admin/AccommodationTable"
import { CountryAutoComplete } from "../../../models/Autocomplete"
import msalRestClient from "../../../services/clients/MsalRestClient"

type AccommodationTableEntryProps = {

    index: number,
    value: PutAccommodationSetEntry,
    selectedCountries: number[]

    /**
     * Callback method that gets executed when changes has been done.
     * @param entry
     * @param entryIndex
     * @returns
     */
    onConfirm: (entry: PutAccommodationSetEntry, entryIndex: number) => void,

    /**
     * Callback method that gets executed when entry should be deleted.
     * @param entryIndex
     * @returns
     */
    onDelete: (entryIndex: number) => void
}

const AccommodationTableEntry = ({ index, value, selectedCountries, onConfirm, onDelete }: AccommodationTableEntryProps) => {

    const [entry, setEntry]         = useState<PutAccommodationSetEntry>(value);
    const [countries, setCountries] = useState<CountryAutoComplete[]>([]);

    useEffect(() => {
        /* Fetch Countries for automcomplete dropdowns */
        msalRestClient.get<CountryAutoComplete[]>("/api/countries/autocomplete")
            .then(response => {
                setCountries(response.data);
            })
    }, []);

    /**
     * Handles on Submit method for edit or create button click.
     */
    const onSubmit = () => {
        /* TODO: Impelement some kind of validation */
        entry.mode = EntryMode.Display;
        onConfirm(entry, index);
    }

    /**
     * Renders a JSX Element that represents a single button for handling different kind of states.
     */
    const renderButton = () => {

        switch (entry.mode) {
            case EntryMode.Display: return <><button className="btn btn-warning" onClick={e => setEntry(x => ({ ...x, mode: EntryMode.Edit }))}><i className="bi bi-pencil"></i></button> | <button className="btn btn-danger" onClick={e => onDelete(index)}><i className="bi bi-trash"></i></button></>
            case EntryMode.Edit:    return   <button className="btn btn-success" onClick={onSubmit}><i className="bi bi-check-lg"></i></button>
            case EntryMode.Create:  return   <button className="btn btn-success" onClick={onSubmit}><i className="bi bi-check-lg"></i></button>
        }
    }

    /**
     * Render JSX Element
     */
    return (
        <tr key={index}>
            <td>{entry.mode === EntryMode.Display ? (countries.find(x => x.value === entry.countryId)?.displayValue) : <select className="form-select" defaultValue={entry.countryId} onChange={e => setEntry(x => ({ ...x, countryId: Number(e.target.value) }))}>{countries.filter(x => !selectedCountries.includes(x.value)).map((value, index2) => { return (<option key={index + "_" + index2} value={value.value}>{value.displayValue}</option>) })}</select>}</td>
            <td>{entry.mode === EntryMode.Display ? (entry.accommodation) + " EUR" : (<input type="number" onChange={e => setEntry(x => ({ ...x, accommodation: Number(e.target.value) }))} value={entry.accommodation} className="form-control"></input>)}</td>
            <td>{renderButton()}</td>
        </tr>
    )

}
export default AccommodationTableEntry;